export const productLineToQuantityName = {
  SALES: 'SALES_SEAT',
  SERVICE: 'SERVICE_SEAT',
  COMMERCE: 'COMMERCE_SEAT',
  MARKETING: 'CONTACTS'
};
export const productLineToSkuCategoryName = {
  SALES: 'SALES_PRODUCTS',
  SERVICE: 'SERVICE_HUB_PRODUCTS',
  MARKETING: 'MARKETING_PRODUCTS',
  OPERATIONS: 'OPERATIONS_HUB_PRODUCTS',
  CMS: 'CMS_HUB_PRODUCTS',
  COMMERCE: 'COMMERCE_PRODUCTS'
};